/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 27th 2022, 12:06:57 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APISERVICEPATHS, useAPIFetchItem, UseAPIFormSpec, useAPIForm } from "lib/api";
import { RegistrationProfile, RegistrationProfileValidationSchema, RegistrationProfilePatch, User } from "lib/schemas";

const fetchUserEndPoint = APISERVICEPATHS.userDetails;

export const useAPIFetchUserDetails = () =>
  useAPIFetchItem<User>({
    apiServicePath: fetchUserEndPoint,
    makeRequestOnInitialMount: false,
  });

const registrationProfileAPIServicePath = APISERVICEPATHS.registrationProfiles;

export const useRegistrationProfileAPIForm = (
  profileData: RegistrationProfilePatch,
  setProfileData: UseAPIFormSpec<RegistrationProfile>["setAPIFormResponse"],
  validationSchema?: UseAPIFormSpec<RegistrationProfile>["apiFormDataValidationSchema"],
  successNotificationMessage?: string
) =>
  useAPIForm<RegistrationProfilePatch, RegistrationProfile>({
    apiServicePath: registrationProfileAPIServicePath,
    apiFormDefaultValues: profileData,
    primaryKey: "id",
    apiFormDataValidationSchema: validationSchema ?? RegistrationProfileValidationSchema,
    apiInitialFetchId: null,
    titleKey: "firstname",
    successNotificationMessage,
    formResetDependencyArray: [profileData?.id],
    setAPIFormResponse: setProfileData,
    method: "PATCH",
  });
